/**
 * Converts a key/string like "FUNNEL_STATUS" or "funnel-status"
 * into a display-friendly "Funnel Status".
 */
export function toDisplayFromKey(key?: string | null): string {
  if (!key) return '';
  const normalized = String(key)
    .replace(/[._-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!normalized) return '';

  return normalized
    .toLowerCase()
    .split(' ')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ''))
    .join(' ');
}

/**
 * Simple start case for arbitrary strings.
 */
export function toStartCase(value?: string | null): string {
  return toDisplayFromKey(value);
}

/**
 * Truncates a string to a maximum length and appends ".." if truncated.
 * @param text The string to truncate.
 * @param maxLength Maximum length before truncation (default: 20).
 * @returns The truncated string with ".." appended if needed.
 */
export function truncate(text: string, maxLength = 20): string {
  if (text.length <= maxLength) {
    return text;
  }

  return text.slice(0, maxLength) + '..';
}

/**
 * Trims a string and returns undefined when the resulting value is empty.
 */
export function trimToUndefined(value?: string | null): string | undefined {
  const trimmed = value?.trim();
  return trimmed ?? undefined;
}
